"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLibraryPayloadValidator = exports.updateLibraryPayloadSchema = exports.createDefaultCommunityLibrary = exports.getChildren = void 0;
var channel_1 = require("./channel");
var suretype_1 = require("suretype");
var common_1 = require("../../common");
// ==========================
// utils
// ==========================
function getChildren(parentId, libraryItems) {
    var children = libraryItems.filter(function (val) { return val.parentId === parentId; });
    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
        var child = children_1[_i];
        children.push.apply(children, getChildren(child.id, libraryItems));
    }
    return children;
}
exports.getChildren = getChildren;
function createDefaultCommunityLibrary() {
    return {
        details: {
            libraryItems: [],
        }
    };
}
exports.createDefaultCommunityLibrary = createDefaultCommunityLibrary;
//
// export function createChannelDataFromArgs(args: CreateCha) {
//     const createData = args.createData
//     let extraData
//     if (createData.type === "folder") {
//         extraData = {
//             type: createData.type,
//         } as FolderChannelExtraData
//     }
//     if (createData.type === "webpage") {
//         extraData = {
//             type: createData.type,
//             url: createData.url,
//             fileId: createData.fileId
//         } as WebpageChannelExtraData
//     }
//     if (createData.type === "pdf" || createData.type === "pdfGlobal") {
//         const pdfFetchInfo = createData.pdfFetchInfo.type === "cloud" ?
//             {type: "cloud"} : createData.pdfFetchInfo
//         extraData = {
//             type: createData.type,
//             fileId: createData.fileId,
//             numPages: createData.numPages,
//             pdfFetchInfo
//         } as PDFChannelExtraData
//     }
//     if (createData.type === "chat") {
//         extraData = {
//             type: createData.type
//         } as ChatChannelExtraData
//     }
//     if (createData.type === "announcement") {
//         return {
//             type: createData.type
//         } as AnnouncementChannelExtraData
//     }
//     return {
//         parentId: args.parentId,
//         details: {
//             name: args.name,
//             ...(args.description) && {
//                 description: args.description
//             },
//             extraData
//         },
//     } as ChannelFirestoreData
// }
// ==========================
// actions
// ==========================
// --------------------------
// update library
// --------------------------
// const LibraryCreateChannelActionSchema = v.object({
//     actionType: v.string().const("create").required(),
//     parentId: idNullableSchema.required(),
//     channelId: idSchema.required(),
//     name: channelNameSchema.required(),
//     description: v.string().maxLength(2000),
//     createData: v.anyOf([
//         v.object({
//             type: v.string().const("webpage").required(),
//             fileId: fileIdSchema.required(),
//             url: urlSchema
//         }),
//         v.object({
//             type: v.string().const("pdf").required(),
//             fileId: fileIdSchema.required(),
//             numPages: v.number().required(),
//             pdfFetchInfo: PdfFetchInfoSchema.required()
//         }),
//         v.object({
//             type: v.string().const("pdfGlobal").required(),
//             fileId: fileIdSchema.required(),
//             numPages: v.number().required(),
//             pdfFetchInfo: PdfFetchInfoSchema.required()
//         }),
//         v.object({
//             type: v.string().const("folder").required()
//         }),
//         v.object({
//             type: v.string().const("chat").required(),
//         }),
//         v.object({
//             type: v.string().const("announcement").required(),
//         }),
//     ]).required()
//
// })
// export type LibraryCreateChannelAction = TypeOf<typeof LibraryCreateChannelActionSchema>
var LibraryCreateFolderActionSchema = suretype_1.v.object({
    actionType: suretype_1.v.string().const("createFolder").required(),
    parentId: common_1.idNullableSchema.required(),
    channelId: common_1.idSchema.required(),
    name: channel_1.channelNameSchema.required(),
});
var LibraryDeleteChannelActionSchema = suretype_1.v.object({
    actionType: suretype_1.v.string().const("delete").required(),
    channelId: common_1.idSchema.required()
});
var LibraryMoveChannelActionSchema = suretype_1.v.object({
    actionType: suretype_1.v.string().const("move").required(),
    channelId: common_1.idSchema.required(),
    newParentId: common_1.idNullableSchema.required(),
});
var LibraryRenameChannelActionSchema = suretype_1.v.object({
    actionType: suretype_1.v.string().const("rename").required(),
    newName: channel_1.channelNameSchema.required(),
    channelId: common_1.idSchema.required(),
});
var LibraryActionSchema = suretype_1.v.anyOf([
    LibraryCreateFolderActionSchema,
    LibraryDeleteChannelActionSchema,
    LibraryMoveChannelActionSchema,
    LibraryRenameChannelActionSchema
]);
exports.updateLibraryPayloadSchema = suretype_1.v.object({
    // cmd: v.string().const("updateLibrary").required(),
    communityId: common_1.idSchema.required(),
    actions: suretype_1.v.array(LibraryActionSchema).minItems(1).required()
});
exports.updateLibraryPayloadValidator = (0, suretype_1.compile)(exports.updateLibraryPayloadSchema);
